import { propertySearch } from 'Vanilla/tracking/property_data_subscription_tracking'
;(function () {
  function PermitMapCtrl(
    $rootScope,
    $scope,
    $timeout,
    propertiesService,
    propertySearchService,
    zoomService,
    markerService,
    localStorageModel
  ) {
    // $scope.is_nationwide = true;
    $rootScope.in_progress = true
    $scope.zoom = zoomService

    $scope.wasDragged = false
    $scope.autoRefreshOn = localStorageModel.get('mapAutoRefresh') || false
    $scope.toggleAutoRefresh = function () {
      if ($scope.autoRefreshOn) {
        localStorageModel.set('mapAutoRefresh', true)
      } else {
        localStorageModel.remove('mapAutoRefresh')
      }
    }

    $scope.propertySearch = propertySearchService
    var TEST_MOBILE = false
    $scope.carousel = { index: 0 }

    $scope.geolocate = function () {
      $scope.$broadcast('geolocate')
    }

    $scope.queryAddress = function () {
      propertySearch()
      $scope.propertySearch.queryAddress()
    }

    $scope.addressText = function (withState) {
      if ($scope.location.nationWide) {
        return 'in The United States'
      } else if ($scope.location && $scope.location.city) {
        var text = 'in ' + $scope.location.city
        return withState ? text + ', ' + $scope.location.state : text
      }
    }

    $scope.setLocation = function () {
      if ($scope.propertySearch.city && $scope.propertySearch.state) {
        $scope.location = {
          city: $scope.propertySearch.city,
          state: $scope.propertySearch.state,
        }
      }
    }

    $scope.init = function (params) {
      $scope.location = {
        city: params.city,
        state: params.state,
        nationWide: params.query === 'nation-wide',
      }
    }

    $scope.$on('properties.allPinsFromAPILoaded', function (event, args) {
      $scope.$apply(function () {
        apiLoaded(args)
      })
    })

    $scope.$on('properties.noPinsFromAPILoaded', function (event, args) {
      $scope.$apply(function () {
        apiLoaded(args)
      })
    })

    var apiLoaded = function (args) {
      $scope.setLocation()
      $rootScope.in_progress = false
      $scope.is_nationwide = false
      $scope.showMessage = false
      $('.sidebar-wrapper').animate({ scrollTop: 0 }, 'slow')
      if (typeof args !== 'undefined') {
        $scope.properties = args
      } else {
        $scope.properties = []
      }
      var match = false
      if (
        typeof $scope.properties !== 'undefined' &&
        getURLParameter('full_address')
      ) {
        for (var i = 0; i < $scope.properties.length; i++) {
          if ($scope.properties[i].was_searched) {
            $scope.selected = $scope.properties[i]
            match = true
            break
          }
        }
      }
      if (
        $scope.properties.length >=
          bzGlobal.applicationConstants.permitMapResults &&
        !$scope.is_nationwide
      ) {
        $scope.showMessage = true
      }

      if ((TEST_MOBILE || isMobile.check()) && $scope.properties[0]) {
        selectPinByStreetAddress($scope.properties[0].street)
      }

      if (!match) {
        $scope.selected = null
      }

      $scope.propertySearch.allowRedoSearch = false
      //search query submitted but no exact match; drop marker
      if (
        $scope.propertySearch.searched() &&
        $scope.propertySearch.street_number &&
        !$scope.selected &&
        zoomService.isMaxZoomLevel()
      ) {
        var notFoundMarker = propertiesService.addNotFoundMarker(
          $scope.propertySearch,
          $scope.map
        )
        $scope.$broadcast('openInfoWindow', notFoundMarker)
      }
    }

    if (TEST_MOBILE || isMobile.check()) {
      $scope.$watch('carousel.index', function () {
        if (
          typeof $scope.carousel.index !== 'undefined' &&
          typeof $scope.properties !== 'undefined'
        ) {
          selectPinByStreetAddress(
            $scope.properties[$scope.carousel.index].street
          )
        }
      })
    }

    var selectPinByStreetAddress = function (street) {
      var marker = propertiesService.getPinByAddress(street)
      markerService.select(marker)
    }

    $scope.$on('pin.clicked', function (event, marker) {
      $scope.selected = marker.property
      if (TEST_MOBILE || isMobile.check()) {
        $scope.$apply(function () {
          var index = $scope.properties.indexOf(marker.property)
          if (index > -1) {
            $scope.carousel.index = index
          }
        })
      }
    })

    $scope.$on('properties.clusterClicked', function (event, args) {
      $rootScope.in_progress = true
      $scope.is_nationwide = false
      $rootScope.$digest()
    })

    $scope.$on('zoom-property', function (event, property, skipAPI) {
      $scope.selected = property
      $scope.showMessage = false
    })

    $scope.$on('properties.nationwideClustersLoaded', function (event) {
      $rootScope.in_progress = false
      $scope.is_nationwide = true
      $rootScope.$digest()
    })

    $rootScope.$on('dragstart', function (event) {
      if (!$scope.is_nationwide) {
        $scope.wasDragged = true
        $scope.propertySearch.allowRedoSearch = true
        $scope.$apply()
      }
    })

    $rootScope.$on('mapidle', function (event) {
      if ($scope.wasDragged) {
        $scope.wasDragged = false
        if (!$scope.is_nationwide && $scope.autoRefreshOn) {
          $scope.propertySearch.redoSearch()
        }
      }
    })

    $scope.$on('zoom.clicked', function (event, is_nationwide) {
      $scope.is_nationwide = is_nationwide
      $scope.showMessage = false
    })

    $rootScope.$on('mapInitialized', function (event, map) {
      $scope.map = map
    })
  }

  bz_app.controller('PermitMapCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    'propertiesService',
    'propertySearchService',
    'zoomService',
    'markerService',
    'localStorageModel',
    PermitMapCtrl,
  ])
})()
